import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import { Link } from "react-router-dom";
import HeaderOne from '../common/header/HeaderOne';
import CounterUpFour from '../elements/counterup/CounterUpFour';
import ServiceOne from '../elements/service/ServiceOne';
import BrandOne from '../elements/brand/BrandOne';
import ScrollAnimation from 'react-animate-on-scroll';
import { FiArrowRight } from 'react-icons/fi';
import PortfolioOne from '../elements/portfolio/PortfolioOne';
import SlipThree from '../elements/split/SlipThree';
import TestimonialThree from '../elements/testimonial/TestimonialThree';
import AccordionOne from "../elements/accordion/AccordionOne";
import ChooseTheBest from "../elements/ChooseTheBest/ChooseTheBest";
import OurTechnologies from "../elements/OurTechnologies/OurTechnologies";
import CustomFooter from "../elements/CustomFooter/CustomFooter";

const BannerData = [
	{
		video: "/images/videos/shangai_video.webm",
		// video: "/images/videos/shangai_video.mp4",
		title: "Ideas to Digital Experiences.",
		description: "At YGS Web Solutions, we turn imagination into reality—websites, apps, <br />logos, platforms, anything—on time, on budget."
	},
]


const WebAgency = () => {
	return (
		<>
			<SEO title="Web Agency" />
			<main className="page-wrapper">
				<HeaderOne btnStyle="btn-small" HeaderSTyle="header-not-transparent" />


				{/* Start Slider Area  */}
				<div className="slider-area slider-style-8" style={{ height: '100vh', width: '100vw', position: 'relative', overflow: 'hidden' }}>
					{BannerData.map((data, index) => (
						<div key={index} className="single-slide" style={{ height: '100vh', width: '100%', position: 'relative' }}>
							<video
								autoPlay
								loop
								muted
								playsInline
								preload="none"
								loading="lazy"
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									objectFit: 'cover',
									zIndex: -1,
								}}
							>
								<source src={data.video} type="video/mp4" />
								Your browser does not support the video tag.
							</video>
							{/* Dark Overlay */}
							<div
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									backgroundColor: 'black',
									opacity: 0.6,
									zIndex: 0,
								}}
							/>
							<div className="container" style={{ height: '100%' }}>
								<div className="row align-items-center" style={{ height: '100%' }}>
									<div className="col-lg-12" style={{ height: '100%' }}>
										<div
											className="inner text-center"
											style={{
												display: 'flex',
												flexDirection: 'column',
												justifyContent: 'center',
												alignItems: 'center',
												minHeight: '100vh',
												position: 'relative',
												zIndex: 1,
											}}
										>
											<ScrollAnimation animateIn="fadeInUp"
												animateOut="fadeInOut"
												animateOnce={true}
												className="button-group">
												<span className="subtitle theme-gradient">This is Who We Are</span>
												<h1 className="title" dangerouslySetInnerHTML={{ __html: data.title }}></h1>
												<p className="description" dangerouslySetInnerHTML={{ __html: data.description }}></p>
												<div className="button-group mt--30">
													<Link className="btn-default round btn-icon" to="/contact">Contact Us</Link>
													<Link className="btn-default round btn-border btn-icon" to="/services">Explore Now <i className="icon"><FiArrowRight /></i></Link>
												</div>
											</ScrollAnimation>
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
				<br />
				<br />
				{/* Start Brand Area  */}
				<div className="rwt-brand-area rn-section-gapBottom">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<SectionTitle
									textAlign="text-center"
									radiusRounded=""
									subtitle="Our Awesome Clients"
									title="Clients That Trust Us"
									description=""
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-12 mt--40">
								<BrandOne brandStyle="brand-style-1" />
							</div>
						</div>
					</div>
				</div>
				{/* End Brand Area  */}

				<Separator />
				{/* Start Service Area  */}
				<div className="service-area rn-section-gapTop">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6">
								<div className="content">
									<h3 className="title">Turning Bold Ideas Into Impactful, Innovative, And Meaningful Digital Journeys.</h3>
								</div>
							</div>
							<div className="col-lg-6">
								<p className="mb--10">Since 2020, YGS Web Solutions Pvt. has been turning big ideas into reality. Based in India, we serve clients across China, the USA, Canada, and beyond offering strategy, design, development, and digital marketing to bring your vision to life.</p>
								<div className="readmore-btn">
									<Link className="btn-read-more" to={`${process.env.PUBLIC_URL + "/about-us"}`}><span>View More</span></Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Service Area  */}

				{/* Start Counterup Area  */}
				<div className="our-counterup-area" >
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="rwt-counterup-area ptb--60">
									<div className="col-lg-12">
										<CounterUpFour column="col-lg-3 col-md-6 col-sm-6 col-12" counterStyle="counter-style-4" textALign="text-center" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Counterup Area  */}
			</main>


			<Separator />
			<ChooseTheBest />
			<Separator />

			<main className="page-wrapper">

				{/* Start Service Area  */}
				<div className="rn-service-area rn-section-gap">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<SectionTitle
									textAlign="text-center"
									radiusRounded=""
									subtitle="CORE SERVICES"
									title="From A to Z, We Offer An<br /> Expansive Suite Of Services"
								/>
							</div>
						</div>
						<ServiceOne
							serviceStyle="service__style--1 radius mt--25 rbt-border"
							textAlign="text-start"
						/>
					</div>
				</div>
				{/* End Service Area  */}
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: `2rem`, marginTop: '-4rem', marginBottom: '8rem' }}>
					<ScrollAnimation
						animateIn="fadeInUp"
						animateOut="fadeInOut"
						animateOnce={true}
						className="button-group">
						<Link className="btn-default round btn-icon" to="/contact">GET IN TOUCH <i className="icon"><FiArrowRight /></i></Link>
					</ScrollAnimation>
				</div>
				<Separator />
				<div className="main-content">
					<div className="rwt-portfolio-area rn-section-gap">
						<div className="container">
							<div className="row">
								<div className="col-lg-12">
									<SectionTitle
										textAlign="text-center"
										radiusRounded=""
										subtitle="PORTFOLIO"
										title="A QUICK GLANCE OF OUR<br /> RECENT PROJECTS"
										description=""
									/>
								</div>
							</div>
							<PortfolioOne VisibleCount={4} home={true} Column="col-lg-6 col-md-6 col-sm-12 col-12 mt--30 portfolio" />
						</div>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: `7rem` }}>
							<ScrollAnimation
								animateIn="fadeInUp"
								animateOut="fadeInOut"
								animateOnce={true}
								className="button-group">
								<Link className="btn-default round btn-border btn-icon" to="/portfolio">VIEW FULL PORTFOLIO <i className="icon"><FiArrowRight /></i></Link>
							</ScrollAnimation>
						</div>
					</div>
				</div>
				<div className="rwt-split-area rn-section-gap" style={{ marginTop: '-9rem', marginBottom: '-9rem' }}>
					<div className="wrapper">
						<SlipThree />
					</div>
				</div>
				{/* End Elements Area  */}

				{/* Start Elements Area  */}
				<div className="rwt-elements-area rn-section-gap">
					<div className="container">
						<div className="row mb--20">
							<div className="col-lg-12">
								<SectionTitle
									textAlign="text-center"
									radiusRounded=""
									subtitle="Client Feedback"
									title="Testimonial."
								/>
							</div>
						</div>
						<TestimonialThree teamStyle="" />
					</div>
				</div>
			</main>

			{/* End Elements Area  */}


			<Separator />

			<OurTechnologies />

			<Separator />

			<main className="page-wrapper">

				<Separator />
				{/* Start Accordion Area  */}
				<div className="rn-accordion-area rn-section-gap">
					<div className="container">
						<div className="row">
							<div className="col-lg-10 offset-lg-1">
								<SectionTitle
									textAlign="text-center"
									radiusRounded=""
									subtitle="FAQs"
									title="Frequently Asked Questions"
									description=""
								/>
							</div>
						</div>
						<div className="row mt--35 row--20">
							<div className="col-lg-10 offset-lg-1">
								<AccordionOne customStyle="" />
							</div>
						</div>
					</div>
				</div>
				{/* End Accordion Area  */}
			</main>

			<CustomFooter />
		</>
	)
}
export default WebAgency;